import Fuse from 'fuse.js'
import { FUSE_OPTIONS } from './fuseSettings'

export const searchData = (query, items) => {
  const textInputValue = query.length ? query : ' '
  const searchedItems = new Fuse(items, FUSE_OPTIONS).search(textInputValue).map((searchedItem) => searchedItem.item)

  return searchedItems
}
